// extracted by mini-css-extract-plugin
module.exports = {"container":"AccountSettingsSearchForm_container__3sktU","buttonText":"AccountSettingsSearchForm_buttonText__1Ww-q"};